export default __webpack_public_path__ + "static/media/tablets.85e61eb7.png";